import * as React from 'react';
import './index.scss';
import Typing from 'react-typing-animation';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

interface Props {
    greeting: string;
    isDay: boolean;
}

interface State {
    typingFinished: boolean;
}

class TextIntro extends React.Component<Props, State> {
    private interval: number;
    private containerRef = React.createRef<HTMLDivElement>();
    private container2Ref = React.createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            typingFinished: false,
        };
    }

    public componentDidMount() {
        this.interval = window.setInterval(() => {
            this.scrollContainer(this.containerRef);
        }, 1000)
    }

    public componentWillUnmount() {
        this.clearInterval();
    }

    private clearInterval = () => {
        window.clearInterval(this.interval);
    }

    private scrollContainer = (ref: React.RefObject<HTMLDivElement>) => {
        if (!ref || !ref.current) {
            return ;
        }
        ref.current.scrollTop = ref.current.scrollHeight + 1000;
    }

    private onFinishedTyping = () => {
        this.setState({
            typingFinished: true,
        });
        this.clearInterval();
        if (!this.container2Ref || !this.container2Ref.current) {
            return ;
        }
        this.container2Ref.current.scrollIntoView({ block: 'end', behavior: "smooth" })
    };

    render(): JSX.Element {
        const { typingFinished } = this.state;
        const { greeting, isDay } = this.props;
        const delayLong = 400;
        const delayShort = 400;
        const speed = 25;
        const experience = new Date().getFullYear() - 2005

        if (typingFinished) {
            return (
                <div className="text-wrapper">
                    <div className={classnames('text-pad', {'is-day': isDay})}>
                        <div className="primary">{greeting}, my name is Nick Avasiloi.</div>
                        <div>I'm a Full-Stack engineer with over {experience} years expertise in</div>
                        <div>designing and developing applications for Web, iOS, Android and Cloud platforms.</div>
                        <div>Excellent in JavaScript, JAVA, Swift, PHP, Python (see more at my <Link to="/skills" className="link hvr-sweep-to-right">skills map</Link>).</div>
                        <div>Experienced in AI, LLM, Deep Learning, DevOps, BI</div>
                        <div>Passionate about Artificial Intelligence and Blockchain.</div>
                        <div className="penult">You can visit my <Link to="/blog" className="link hvr-sweep-to-right">Blog</Link> and <Link to="/portfolio" className="link hvr-sweep-to-right">Portfolio</Link> pages.</div>
                        <div ref={this.container2Ref} className="enquires">Get in contact via email at <a href="mailto:hello@nick.engineering" className="link hvr-sweep-to-right">hello@nick.engineering</a> or via <Link to="/contact" className="link hvr-sweep-to-right">contact form</Link></div>
                    </div>
                </div>
            );
        }

        return (
            <div className="text-wrapper">
                <div ref={this.containerRef} className={classnames('text-pad', {'is-day': isDay})}>
                    <Typing speed={speed} onFinishedTyping={this.onFinishedTyping} cursorClassName={classnames('typing-cursor', {'is-day': isDay})}>
                        <div className="primary">
                            <span>{greeting}, </span>
                            <Typing.Delay ms={delayLong} />
                            <span>my name is Nick Avasiloi.</span>
                        </div>
                        <div>
                            <span>I'm a Full-Stack engineer with over {experience - 1}</span>
                            <Typing.Backspace count={2} delay={delayLong} />
                            <span>{experience}</span>
                            <span> years expertise in</span>
                        </div>
                        <div>designing and developing applications for Web, iOS, Android and Cloud platforms.</div>
                        <Typing.Delay ms={delayLong} />
                        <div>Excellent in JavaScript, JAVA, Swift, PHP, Python (see more at my <Link to="/skills" className="link hvr-sweep-to-right">skills map</Link>).</div>
                        <Typing.Delay ms={delayShort} />
                        <div>Experienced in AI, LLM, Deep Learning, DevOps, BI</div>
                        <Typing.Delay ms={delayShort} />
                        <div>Passionate about Artificial Intelligence and Blockchain.</div>
                        <Typing.Delay ms={delayLong} />
                        <div className="penult">
                            You can visit my <Link to="/blog" className="link hvr-sweep-to-right">Blog</Link> and <Link to="/portfolio" className="link hvr-sweep-to-right">Portfolio</Link> pages.
                        </div>
                        <Typing.Delay ms={delayShort} />
                        <div className="enquires">Get in contact via email at <a href="mailto:hello@nick.engineering" className="link hvr-sweep-to-right">hello@nick.engineering</a> or via <Link to="/contact" className="link hvr-sweep-to-right">contact form</Link></div>
                    </Typing>
                </div>
            </div>
        );
    }
}

export default TextIntro;


// WEBPACK FOOTER //
// ./src/components/Home/TextIntro/index.tsx